export default function Star({ filled, className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 1600 1600"
      fill={filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth={100}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M831.44 159.627L1018.13 537.947C1023.26 548.322 1033.07 555.509 1044.51 557.135L1462.01 617.823C1475.2 619.698 1486.2 628.948 1490.33 641.635C1494.39 654.322 1491.01 668.26 1481.45 677.572L1179.32 972.065V972.003C1171.07 980.065 1167.32 991.691 1169.26 1003.07L1240.57 1418.88C1242.82 1432 1237.44 1445.25 1226.63 1453.13C1215.82 1460.94 1201.51 1462 1189.76 1455.82L816.316 1259.44C806.129 1254.13 793.879 1254.13 783.691 1259.44L410.251 1455.82C398.501 1462 384.188 1460.94 373.376 1453.13C362.564 1445.25 357.188 1432 359.439 1418.88L430.751 1003.07C432.688 991.691 428.938 980.066 420.688 972.003L118.555 677.576C108.992 668.264 105.617 654.326 109.68 641.639C113.805 628.951 124.805 619.702 137.992 617.827L555.499 557.139C566.936 555.514 576.749 548.326 581.873 537.951L768.567 159.631C774.504 147.693 786.692 140.131 800.004 140.131C813.316 140.131 825.504 147.693 831.441 159.631L831.44 159.627Z" />
    </svg>
  );
}
